var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from 'styled-components';
import { COLORS, Image, SIZES } from '@fupa/fupa-uikit';
import React, { memo } from 'react';
import Device from 'app/services/Device';
import { desktopContentWidth } from 'app/styles/media';
import { Emblem } from 'app/components/icons';
const EmblemContainer = styled.div.withConfig({
  componentId: "sc-2gvhqx-0"
})(["height:", ";width:", ";background-color:", ";display:flex;align-items:center;justify-content:center;border-radius:50%;", ""], SIZES['20'], SIZES['20'], COLORS.white, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: ", ";\n    width: ", ";\n  "])), SIZES['32'], SIZES['32']));
const TeamEmblem = /*#__PURE__*/memo(_ref => {
  let {
    team
  } = _ref;
  const getEmblemSize = () => {
    const isClient = new Device().isClient();
    if (isClient) {
      const isDesktop = window.matchMedia("(min-width: ".concat(desktopContentWidth, "px)")).matches;
      return isDesktop ? 24 : 14;
    } else {
      return 14;
    }
  };
  const imageProps = team === null || team === void 0 ? void 0 : team.getImageProps();
  return /*#__PURE__*/React.createElement(EmblemContainer, null, imageProps ? /*#__PURE__*/React.createElement(Image, _extends({}, imageProps, {
    width: getEmblemSize(),
    height: getEmblemSize()
  })) : /*#__PURE__*/React.createElement(Emblem, {
    style: {
      color: COLORS.lightGrey,
      fontSize: getEmblemSize()
    }
  }));
}, teamIsEqual);
function teamIsEqual(prevProps, nextProps) {
  var _prevProps$team, _nextProps$team;
  return ((_prevProps$team = prevProps.team) === null || _prevProps$team === void 0 ? void 0 : _prevProps$team.id) === ((_nextProps$team = nextProps.team) === null || _nextProps$team === void 0 ? void 0 : _nextProps$team.id);
}
export default TeamEmblem;